import auth from '@udacity/ureact-hoth';

import { publicEnv } from '~/features/environment/public';
import { logger } from '~/features/logging/logger';
import { getUserIdFromJwt } from '~/features/user/utils/get-user-id-from-jwt';
import { queryUdacityService } from '~/utils/query-udacity-service';

import { Enrollment, enrollmentSchema, fetchEnrollmentQuery } from '../models/program-enrollment';

export async function getEnrollment({ programKey }: { programKey: string }): Promise<Enrollment> {
  const jwt = auth.getJWT();

  if (!jwt) {
    logger.fatal('Missing JWT', {
      file: 'src/features/program/controllers/get-enrollment.ts',
      function: 'getEnrollment',
    });

    throw new Error('Missing JWT');
  }

  const userId = getUserIdFromJwt(jwt);

  if (!userId) {
    logger.fatal('Provided JWT does not contain a user ID', {
      file: 'src/features/program/controllers/get-enrollment.ts',
      function: 'getEnrollment',
    });

    throw new Error('Provided JWT does not contain a user ID');
  }

  return await queryUdacityService({
    url: publicEnv.NEXT_PUBLIC_CLASSROOM_CONTENT_URL,
    zodSchema: enrollmentSchema,
    authorization: `Bearer ${jwt}`,
    body: JSON.stringify({
      query: fetchEnrollmentQuery,
      variables: { userId, key: programKey },
    }),
  });
}
